import React from "react";
import { useNavigate } from "react-router-dom";

const FallBackMessage = () => {
  const userData = JSON.parse(sessionStorage.getItem("userData"));

  const navigate = useNavigate();
  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "70vh" }}
    >
      <div
        className="card shadow-lg border-0 text-center p-4"
        style={{ maxWidth: "500px", width: "100%", borderRadius: "16px" }}
      >
        <div className="mb-3">
          <i
            className="bi bi-lock-fill text-warning"
            style={{ fontSize: "50px" }}
          ></i>
        </div>

        <h3 className="fw-bold mb-2">Subscription Required</h3>

        <p className="text-muted mb-4">
          This feature is available only for subscribed users. Please upgrade
          your plan to unlock full access.
        </p>

        <div className="d-flex justify-content-center gap-3">
          <button
            className="btn btn-warning text-white"
            onClick={() =>
              window.open("https://perennialcode.in/contactus", "_blank")
            }
          >
            Contact Us
          </button>

          <button
            className="btn btn-outline-secondary"
            onClick={() => navigate(`/${userData?.DefaultPath}`)}
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default FallBackMessage;
